export const FolderInfoModel = Symbol.for('FolderInfoModel');
